import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {InView} from 'react-intersection-observer';
import AnalyticsManager from 'app/analytics';
import {
    cleanUpObject,
    combineClassNames,
    getMediaPath,
    urlEncodeString
} from 'app/functions';
import {addPopup, setBenefitPage, setHomepageSearchQuery} from 'redux/actions';
import {AnalyticsParamValues} from 'constants/analytics';
import * as routes from 'constants/routes';
import * as popups from 'constants/popup-types';
import FavoriteButton from '../../shared/favorite-btn';
import placeholder from 'assets/design/benefit_placeholder.svg';
import benefitsLock from 'assets/icons/benefits-lock.svg';
import './benefit.scss';

class Benefit extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shouldLoadImage: false,
            tooltipVisible: false,
        };

        this.loadImage = this.loadImage.bind(this);
        this.handleBenefitClick = this.handleBenefitClick.bind(this);
        this.handleOnMouseEnter = this.handleOnMouseEnter.bind(this);
        this.handleOnMouseLeave = this.handleOnMouseLeave.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextProps.data !== this.props.data
            || nextProps.userData !== this.props.userData
            || nextState.shouldLoadImage !== this.state.shouldLoadImage
            || nextState.tooltipVisible !== this.state.tooltipVisible
        );
    }

    loadImage(inView) {
        if (inView && !this.state.shouldLoadImage) {
            this.setState({shouldLoadImage: true});
        }
    }

    isSameBenefitPage(data) {
        const urlEncodedName = urlEncodeString(data['title']);
        const baseRoute = Number(data['type']) === 1000
            ? routes.commerce
            : routes.benefit;
        const fullRoute = Number(data['type']) === 1000
            ? `${baseRoute}/${data['id']}/${data['option_id']}/${urlEncodedName}`
            : `${baseRoute}/${data['id']}/${urlEncodedName}`;

        return this.props.location.pathname === fullRoute;
    }

    handleBenefitClick(event) {
        const {data, onClick} = this.props;

        if (this.props.shouldAddActionButton && this.isSameBenefitPage(data)) {
            event.preventDefault();
            if (onClick) {
                onClick(data);
            }
            return;
        }

        if (onClick){
            onClick(data)
        }

        this.props.setBenefitPage(false);

        // Check if un-logged users can see this benefit
        if (this.props.data['display_price_members_only'] && !this.props.userData) {
            event.preventDefault();

            this.props.addPopup({
                type: popups.LOGIN,
            });
        } else {
            const pressSource = this.props.analyticsSource || AnalyticsParamValues.UNKNOWN_SOURCE;

            if (parseInt(data['type']) === 1000) {
                AnalyticsManager.logProductPress(data?.['id'], data?.['title'], pressSource);
            } else {
                AnalyticsManager.logBenefitPress(data?.['id'], data?.['title'], data?.maRecommended, pressSource);
            }

            this.props.clearSearchQuery();
        }
    }

    handleOnMouseEnter() {
        if (this.props.data['display_price_members_only']) {
            this.setState({tooltipVisible: true});
        }
    }

    handleOnMouseLeave() {
        this.setState({tooltipVisible: false});
    }

    render() {
        const {
            data,
            userData,
            translations,
            className = undefined,
            smallVersion = false,
            setSelectedId,
            benefitId,
            isSelectBenefit
        } = this.props;
        let newMargin, newMinHeight , newWidth= null
        if (this.props.shouldAddActionButton) {
            newMargin = 0;
            newMinHeight = 0;
            newWidth = '100%';
        }
        const {shouldLoadImage, tooltipVisible} = this.state;

        const urlEncodedName = urlEncodeString(data['title']);

        const baseRoute = Number(data['type']) === 1000
            ? routes.commerce
            : routes.benefit;

        const fullRoute = Number(data['type']) === 1000
            ? `${baseRoute}/${data['id']}/${data['option_id']}/${urlEncodedName}`
            : `${baseRoute}/${data['id']}/${urlEncodedName}`;

        const isDiscount = (data['price_before_discount'] && data['price_before_discount'] !== '0');

        const isImagePath = (data['imagePath'] !== '0');

        const imagePath = isImagePath
            ? getMediaPath(data['imagePath'])
            : getMediaPath(placeholder);

        const tagImage = (data?.['coverImagePath']?.length > 2) ? getMediaPath(data['coverImagePath']) : '';

        const showPrice = (userData || !data['display_price_members_only']);

        const {shouldAddActionButton, hideFavourites} = this.props;

        let isFavorite = false;

        if (userData) {
            if(data?.id){
                isFavorite = userData.favoritesArr.indexOf(data.id.toString()) !== -1;
            }
        }

        return (
            <NavLink
                to={fullRoute}
                onClick={(e) => {
                    if (isSelectBenefit) {
                        e.preventDefault();
                        e.stopPropagation();
                        setSelectedId(benefitId);
                        return;
                    } else {
                        this.handleBenefitClick(e);
                    }
                }}
                className={combineClassNames(
                    'benefit-wrapper',
                    smallVersion && 'benefit-wrapper_small-version',
                    className,
                    shouldAddActionButton && 'subsidy-benefits-slider'
                )}
                data-scarabitem={data?.maRecommended ? data.id : ''}
            >
                <InView
                    as="div"
                    className="top"
                    onChange={this.loadImage}
                    threshold={0.01}
                    triggerOnce={true}
                >
                    {data['has_video'] && (
                        <div className="video-overlay"/>
                    )}

                    {!hideFavourites && (
                        <FavoriteButton
                            data={data}
                            state={isFavorite}
                        />
                    )}

                    {shouldLoadImage && (
                        <>
                            <img
                                src={imagePath}
                                alt={data['title']}
                                className="image"
                            />
                            {tagImage && <img src={tagImage} className={'slider-tag-image'} alt={"falah"}/>}
                        </>
                    )}
                </InView>

                <div className="bottom" style={{ minHeight: newMinHeight}}>
                    <div className="title" style={{margin: newMargin}}>
                        {data['title']}
                    </div>

                    {(showPrice || !smallVersion) && (
                        <div className="deal-wrapper">
                            {!showPrice && (
                                <div className="lock-container">
                                    <img
                                        src={benefitsLock}
                                        alt="Lock Icon"
                                        className="benefits-lock"
                                        onMouseEnter={this.handleOnMouseEnter}
                                        onMouseLeave={this.handleOnMouseLeave}
                                    />

                                    {tooltipVisible && (
                                        <div
                                            className="benefit-tooltip"
                                            onMouseLeave={this.handleOnMouseLeave}
                                        >
                                            {translations['benefit_hidden_price_message']}
                                        </div>
                                    )}
                                </div>
                            )}

                            {showPrice && !isDiscount && (
                                <div className="price">
                                    {data['value']}
                                </div>
                            )}

                            {showPrice && isDiscount && (
                                <div
                                    className={combineClassNames(
                                        'discount',
                                        data['display_type'],
                                        data['currency'],
                                    )}
                                >
                                    {data['price_after_discount']}
                                </div>
                            )}

                            {showPrice && isDiscount && data['price_before_discount'] && (
                                <div
                                    className={combineClassNames(
                                        'old-price',
                                        data['display_type'],
                                        data['currency'],
                                        data['currency'],
                                    )}
                                >
                                    {getCurrency(data['currency'])}
                                    {data['price_before_discount']}
                                </div>
                            )}
                        </div>
                    )}

                    {data['more_details'] && (
                        <div className="more-details">
                            {data['more_details']}
                        </div>
                    )}

                    {(data['small_text'] || !showPrice) && (
                        <div className="bottom-details">
                            {
                                showPrice
                                    ? data['small_text']
                                    : translations['special_benefit_text_button']
                            }
                        </div>
                    )}
                </div>
                {shouldAddActionButton &&
                    <button
                        type="button"
                        onClick={isSelectBenefit ? (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setSelectedId(benefitId);
                        } : undefined}
                        className={'action-button'}
                    >
                        {translations['subsidy_popup_btn_text']}
                    </button>}
            </NavLink>
        );
    }
}

const getCurrency = (currency) => {
    switch (currency) {
        case 'shekel':
            return '₪';
        case 'dollar':
            return '$';
        case 'euro':
            return '€';
    }
};

const mapStateToProps = (store) => {
    return {
        userData: store.config.UserData,
        translations: store.config.Translations,
        iconTypes: cleanUpObject(store.config.IconTypes),
        closedBenefitTypes: store.config.ClosedBenefitTypes,
        deviceState: store.state.deviceState,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        addPopup: (payload) => dispatch(addPopup(payload)),
        setBenefitPage: (payload) => dispatch(setBenefitPage(payload)),
        clearSearchQuery: () => dispatch(setHomepageSearchQuery('')),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps, null, {pure: false})(Benefit));
